import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import { useThemeStore } from '@/stores/theme-store'
import { useAuthStore } from '@/stores/auth-store'
import { TokenSync, ProtectedRoute } from '@/components/auth'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { AppLayout } from '@/layouts'
import { ToastContainer } from '@/components/ui'
import { LoginPage } from '@/pages/LoginPage'
import { CallbackPage } from '@/pages/CallbackPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { PrivacyListPage, PrivacyStatsPage, PrivacyImportPage } from '@/pages/privacy'

function AppContent() {
  const auth = useAuth()
  const { user } = useAuthStore()

  const handleLogout = () => {
    auth.signoutRedirect()
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/callback" element={<CallbackPage />} />

      {/* Protected routes */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout
              user={user ? { name: user.name, email: user.email } : null}
              onLogout={handleLogout}
            />
          </ProtectedRoute>
        }
      >
        <Route path="/" element={<DashboardPage />} />
        <Route path="/privacy" element={<PrivacyListPage />} />
        <Route path="/privacy/stats" element={<PrivacyStatsPage />} />
        <Route path="/privacy/import" element={<PrivacyImportPage />} />
      </Route>
    </Routes>
  )
}

function App() {
  const { theme } = useThemeStore()

  // Apply theme class to document
  useEffect(() => {
    const root = document.documentElement
    if (theme === 'dark') {
      root.classList.add('dark')
    } else {
      root.classList.remove('dark')
    }
  }, [theme])

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <TokenSync />
        <AppContent />
        <ToastContainer />
      </ErrorBoundary>
    </BrowserRouter>
  )
}

export default App
